const prevBtn = document.getElementById('prevBtn');
const nextBtn = document.getElementById('nextBtn');
const container = document.getElementById('d3-graphic');
const dotsContainer = document.getElementById('dots-container');
let items;

function waitForElement(selector, interval = 100, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const poll = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(poll);
        resolve(el);
      } else if (Date.now() - start > timeout) {
        clearInterval(poll);
        reject(new Error(`Timed out waiting for "${selector}"`));
      }
    }, interval);
  });
}


(async () => {
  const el = await waitForElement('.ring-container');
  items = container.querySelectorAll('.ring-container');
})();


prevBtn.addEventListener('click', () => {
  container.scrollBy({ left: -container.offsetWidth, behavior: 'smooth' });
});

nextBtn.addEventListener('click', () => {
  container.scrollBy({ left: container.offsetWidth, behavior: 'smooth' });
});

function updateDots() {
  dotsContainer.innerHTML = '';
  
  const containerWidth = container.offsetWidth;
  // This is the total distance the container can actually move
  const maxScrollableWidth = container.scrollWidth - containerWidth;
  
  // If there's nothing to scroll, we don't need dots at all
  if (maxScrollableWidth <= 0) return;

  // Calculate how many items are visible at once
  const itemsPerView = Math.round(containerWidth / (container.querySelector('div').offsetWidth + 20));
  
  // Calculate dots based on "steps"
  const totalDots = Math.ceil(items.length / itemsPerView);

  console.log(totalDots, itemsPerView)

  for (let i = 0; i < totalDots; i++) {
    const dot = document.createElement('div');
    dot.classList.add('dot');
    if (i === 0) dot.classList.add('active');
    
    dot.addEventListener('click', () => {
      // Calculate target: either one full "page" or the absolute end
      let targetScroll = i * containerWidth;
      
      // Prevent scrolling past the actual content (the "Extra Dot" fix)
      if (targetScroll > maxScrollableWidth) {
        targetScroll = maxScrollableWidth;
      }

      container.scrollTo({
        left: targetScroll,
        behavior: 'smooth'
      });
    });
    dotsContainer.appendChild(dot);
  }
}

// Update the "active" dot based on scroll position
container.addEventListener('scroll', () => {
  const pageIndex = Math.ceil(container.scrollLeft / container.offsetWidth);
  const dots = document.querySelectorAll('.dot');
  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === pageIndex);
  });
});

// Re-calculate dots when the window changes size (Mobile vs Desktop)
let resizeTimer;
window.addEventListener('resize', () => {
  const dots = document.querySelectorAll('.dot');
  dots.forEach((dot, index) => {
    dot.classList.toggle('active', index === 0);
  });
  container.scrollLeft = 0;
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(updateDots, 200); // Debounce to improve performance
});

// Initial call
updateDots();